import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequirementService } from 'src/app/services/requirement.service';


@Component({
    selector: 'app-add-collaborator',
    templateUrl: './add-collaborator.component.html',
    styleUrls: ['./add-collaborator.component.scss'],
    standalone: false
})
export class AddCollaboratorComponent implements OnInit {
	@Output() sendCollab = new EventEmitter<any>();
	@Input() doneReq: boolean;
	@Input() requirementId: number;
	collaboratorAssociates: Array<any>;
	newColbAssoc: Array<any>;
	isCheckbox: boolean = true;
	sentId: number;
	usersSubscribers: Array<any>;
	masterSelected1: boolean;
	checkedList1: any;
	listEmailsColab: Array<string>;
	emailsColab: string;
	searchText: string = '';
  constructor(
		public _requirements: RequirementService,
	) {
		this.masterSelected1 = false;
	}

  ngOnInit() {
		this._requirements.getRequirementAllData(this.requirementId).subscribe(resp => {
			this.usersSubscribers = resp['result']['usersSuscribed'];
			this.collaboratorAssociates = this.usersSubscribers.map((el) => {
					let o = Object.assign({}, el);
					o.isSelected = false;
					return o;
			});
			this.getCheckedItemList1(this.collaboratorAssociates);
		});
  }
	ngOnChanges(): void {
		if (this.doneReq)	{
			this.clearVaraibles();
		}
	}
	/* ADD COLLABORATORS */
	searchThis() {
		if ( this.searchText === ''){
			this.isCheckbox = true;
		} else {
			this.isCheckbox = false;
		}
	}
	checkUncheckAll1() {
    for (var i = 0; i < this.collaboratorAssociates.length; i++) {
      this.collaboratorAssociates[i].isSelected = this.masterSelected1;
    }
    this.getCheckedItemList1(this.collaboratorAssociates);
	}
	isAllSelected1() {
		// The every() method checks if all elements in an array pass a test (provided as a function).
    this.masterSelected1 = this.collaboratorAssociates.every(function(item:any) {
        return item.isSelected == true;
		});
    this.getCheckedItemList1(this.collaboratorAssociates);
  }
	getCheckedItemList1( newFiles: Array<any> ) {
		this.checkedList1 = [];
    for (let i = 0; i < newFiles.length; i++) {
      if(newFiles[i].isSelected)
      this.checkedList1.push(newFiles[i]);
		}
		this.listEmailsColab = this.checkedList1.map( v  => (v.email));
		/* this.emailsColab = this.listEmailsColab.toString(); */
		this.sendCollab.emit(this.listEmailsColab);
	}

	// clear after form submit 
	clearVaraibles()	{
		this.isCheckbox = true;
		this.emailsColab = '';
		this.listEmailsColab = [];
		for( var i in this.collaboratorAssociates){
			this.collaboratorAssociates[i].isSelected = false;
		}
	}

	/* DONE */
}
